import React, { useEffect, useState } from "react";
import { Box, Button, Grid2, Typography } from "@mui/material";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";

const Step2 = ({ tender, setTender, user, setStep, getDraft }) => {
  const [errors, setErrors] = useState({});
  const [inWords, setInWords] = useState();
  const [btnLoading, setBtnLoading] = useState(false);
  const { tenderId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (tender?.bank === "ARG") {
      const getArgBank = async () => {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/bank-detail?username=${user.username}`,
          { headers: { Authorization: `Bearer ${user.accessToken}` } }
        );
        setTender({
          ...tender,
          purchaseBank: res.data.bankName,
          purchaseAccountNumber: res.data.accountNumber,
          purchaseIfsc: res.data.ifscCode,
          purchaseAccountName: res.data.accountName,
          purchaseAccountType: res.data.type,
        });
      };
      getArgBank();
    } else {
      setTender({
        ...tender,
        purchaseBank: tender?.purchaseBank,
        purchaseAccountNumber: tender?.purchaseAccountNumber,
        purchaseIfsc: tender?.purchaseIfsc,
        purchaseAccountName: tender?.purchaseAccountName,
        purchaseAccountType: tender?.purchaseAccountType,
      });
    }
  }, [tender?.bank]);

  const handleChange = (e) => {
    setTender({ ...tender, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
    setInWords(
      e.target.name === "bidValue"
        ? e.target.value !== ""
          ? convertToWords(e.target.value) + " Rupees Only"
          : ""
        : inWords
    );
  };

  const validateForm = () => {
    const newErrors = {};
    const data = tender || {};

    const isEmpty = (value) => !value || value.trim?.() === "";

    if (isEmpty(data.sellerDoc))
      newErrors.sellerDoc = "Seller Documents is required";
    if (isEmpty(data.type)) newErrors.type = "Tender Type is required";
    if (isEmpty(data.technicalExpiry))
      newErrors.technicalExpiry =
        "Time For Technical Clarification is required";
    if (isEmpty(data.bidValue))
      newErrors.bidValue = "Estimated Bid Value is required";
    if (isEmpty(data.evalMethod))
      newErrors.evalMethod = "Evaluation Method is required";
    if (data.mediationClause === "") {
      newErrors.arbitrationClause = "Arbitration Clause is required";
    }
    if (data.mediationClause === "") {
      newErrors.mediationClause = "Mediation Clause is required";
    }

    if (
      data.isBorne === undefined ||
      data.isBorne === null ||
      data.isBorne === ""
    ) {
      newErrors.isBorne = "This question is mandatory to answer";
    } else if (isEmpty(String(data.isBorne))) {
      newErrors.isBorne = "This question is mandatory to answer";
    }

    if (data.isBorne === "false") {
      if (isEmpty(data.bank))
        newErrors.bank = "This question is mandatory to answer";
      if (isEmpty(data.purchaseAmount))
        newErrors.purchaseAmount = "Purchase amount is required";

      if (data.bank === "OWN") {
        if (isEmpty(data.purchaseBank))
          newErrors.purchaseBank = "Bank Name is required";
        if (isEmpty(data.purchaseAccountNumber))
          newErrors.purchaseAccountNumber = "Bank Account Number is required";
        if (isEmpty(data.purchaseIfsc)) {
          newErrors.purchaseIfsc = "IFSC code is required";
        } else {
          const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
          if (!ifscRegex.test(data.purchaseIfsc)) {
            newErrors.purchaseIfsc =
              "Enter a valid IFSC code (e.g., SBIN0001234)";
          }
        }
        if (isEmpty(data.purchaseAccountName))
          newErrors.purchaseAccountName = "Beneficiary Name is required";
        if (isEmpty(data.purchaseAccountType))
          newErrors.purchaseAccountType = "Account Type is required";
      }
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = async () => {
    if (!validateForm()) return;
    setBtnLoading(true);
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/draft?draftTenderId=${tender.draftTenderId}`,
        {
          sellerDoc: tender.sellerDoc,
          type: tender.type,
          technicalExpiry: tender.technicalExpiry,
          bidValue: tender.bidValue,
          evalMethod: tender.evalMethod,
          arbitrationClause: tender.arbitrationClause,
          mediationClause: tender.mediationClause,
          isBorne: tender.isBorne,
          bank: tender.bank,
          purchaseBank: tender.purchaseBank,
          purchaseAmount: tender.purchaseAmount,
          purchaseAccountNumber: tender.purchaseAccountNumber,
          purchaseIfsc: tender.purchaseIfsc,
          purchaseAccountName: tender.purchaseAccountName,
          purchaseAccountType: tender.purchaseAccountType,
        },
        { headers: { Authorization: `Bearer ${user.accessToken}` } }
      );
      setTender(res.data);
      setStep((prev) => prev + 1);
    } catch (error) {
      console.log(error);
    } finally {
      setBtnLoading(false);
    }
  };

  const handleBack = () => {
    navigate(`/dashboard/create-tender/draft/${tender.draftTenderId}`);
    setStep((prev) => prev - 1);
    if (tenderId !== undefined) {
      getDraft();
    }
  };

  const convertToWords = (num) => {
    const a = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const b = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];

    const inWords = (n) => {
      if (n < 20) return a[n];
      if (n < 100)
        return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
      if (n < 1000)
        return (
          a[Math.floor(n / 100)] +
          " Hundred" +
          (n % 100 ? " and " + inWords(n % 100) : "")
        );
      if (n < 100000)
        return (
          inWords(Math.floor(n / 1000)) +
          " Thousand" +
          (n % 1000 ? " " + inWords(n % 1000) : "")
        );
      if (n < 10000000)
        return (
          inWords(Math.floor(n / 100000)) +
          " Lakh" +
          (n % 100000 ? " " + inWords(n % 100000) : "")
        );
      return (
        inWords(Math.floor(n / 10000000)) +
        " Crore" +
        (n % 10000000 ? " " + inWords(n % 10000000) : "")
      );
    };

    return inWords(num);
  };

  return (
    <div style={{ position: "relative" }}>
      {btnLoading && <div className="loading-div"></div>}
      <h2>Create New Tender</h2>
      <div className="progress-container">
        <span className="blue-bar" style={{ width: "33%" }}></span>
      </div>
      <div className="dashboard-container">
        <Typography className="form-title">Tender Details</Typography>
        <Grid2 container columnSpacing={2}>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="sellerDoc">Documents required from seller</label>
            <input
              type="text"
              id="sellerDoc"
              name="sellerDoc"
              className={`${errors.sellerDoc && "input-error"}`}
              onChange={handleChange}
              value={tender && tender.sellerDoc}
            />
            {errors.sellerDoc && <p className="error">{errors.sellerDoc}</p>}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="type">Type of Tender</label>
            <select
              name="type"
              id="type"
              className={`${errors.type && "input-error"}`}
              onChange={handleChange}
              value={tender && tender.type}
            >
              <option value="">Choose a type of tender</option>
              <option value="SERVICE">Service</option>
              <option value="CIVIL">Civil</option>
              <option value="SUPPLY">Supply</option>
              <option value="CONSULTANCY">Consultancy</option>
              <option value="FRAMEWORK">Framework Agreement</option>
              <option value="OTHERS">Others</option>
            </select>
            {errors.type && <p className="error">{errors.type}</p>}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="technicalExpiry">
              Time allowed for Technical Clarifications (in days)
            </label>
            <input
              type="number"
              id="technicalExpiry"
              name="technicalExpiry"
              className={`${errors.technicalExpiry && "input-error"}`}
              onChange={handleChange}
              value={tender && tender.technicalExpiry}
            />
            {errors.technicalExpiry && (
              <p className="error">{errors.technicalExpiry}</p>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="bidValue">Estimated Bid Value (in &#8377;)</label>
            <input
              type="number"
              step={1}
              id="bidValue"
              name="bidValue"
              className={`${errors.bidValue && "input-error"}`}
              onChange={handleChange}
              value={tender && tender.bidValue}
              onKeyDown={(e) => {
                if ([".", ",", "e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
            />
            {inWords && (
              <p
                style={{
                  fontSize: "12px",
                  fontWeight: "700",
                  marginTop: "-4%",
                }}
              >
                In Words: {inWords}
              </p>
            )}
            {errors.bidValue && <p className="error">{errors.bidValue}</p>}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="evalMethod">Evaluation Method</label>
            <select
              name="evalMethod"
              id="evalMethod"
              className={`${errors.evalMethod && "input-error"}`}
              onChange={handleChange}
              value={tender && tender.evalMethod}
            >
              <option value="">-Choose-</option>
              <option value="Total value wise">Total value wise</option>
              <option value="Item wise">Item wise</option>
            </select>
            {errors.evalMethod && <p className="error">{errors.evalMethod}</p>}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="arbitrationClause">Arbitration Clause</label>
            <select
              name="arbitrationClause"
              id="arbitrationClause"
              className={`${errors.arbitrationClause && "input-error"}`}
              onChange={handleChange}
              value={
                tender && tender.arbitrationClause !== undefined
                  ? String(tender.arbitrationClause)
                  : ""
              }
            >
              <option value="">-Choose-</option>
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
            {errors.arbitrationClause && (
              <p className="error">{errors.arbitrationClause}</p>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="mediationClause">Mediation Clause</label>
            <select
              name="mediationClause"
              id="mediationClause"
              className={`${errors.mediationClause && "input-error"}`}
              onChange={handleChange}
              value={
                tender && tender.mediationClause !== undefined
                  ? String(tender.mediationClause)
                  : ""
              }
            >
              <option value="">-Choose-</option>
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
            {errors.mediationClause && (
              <p className="error">{errors.mediationClause}</p>
            )}
          </Grid2>
        </Grid2>
      </div>
      <div className="dashboard-container">
        <Typography className="form-title">Purchase Details</Typography>
        <Grid2 container columnSpacing={2}>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="isBorne">
              Will the tender cost be borne by you?
            </label>
            <select
              className={`${errors.isBorne && "input-error"}`}
              name="isBorne"
              id="isBorne"
              onChange={handleChange}
              value={
                tender && tender.isBorne !== undefined
                  ? String(tender.isBorne)
                  : ""
              }
            >
              <option value="">---Choose---</option>
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
            {errors.isBorne && <p className="error">{errors.isBorne}</p>}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            {tender && String(tender.isBorne) === "false" && (
              <>
                <label htmlFor="bank">
                  Payment of Suppliers will be received in?
                </label>
                <select
                  name="bank"
                  id="bank"
                  onChange={handleChange}
                  value={tender && tender.bank}
                >
                  <option value="">---Choose---</option>
                  <option value="ARG">ARG Account</option>
                  <option value="OWN">Own Account</option>
                </select>
              </>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}></Grid2>

          {tender?.isBorne === "false" && tender?.bank === "ARG" && (
            <Grid2 size={{ xs: 12, sm: 4 }}>
              <label htmlFor="purchaseAmount">
                Tender Purchase Amount (in &#8377;)
              </label>
              <input
                type="number"
                min={0}
                name="purchaseAmount"
                id="purchaseAmount"
                className={`${errors.purchaseAmount && "input-error"}`}
                onChange={handleChange}
                value={tender && tender.purchaseAmount}
              />
              <p style={{ fontSize: "12px", lineHeight: "-1px" }}>
                [Note: Cost of this tender will be borne by suppliers. Purchase
                amount should be 0.1% of Tender Value or Rs. 20,000, whichever
                is lower]
              </p>
              {errors.purchaseAmount && (
                <p className="error">{errors.purchaseAmount}</p>
              )}
            </Grid2>
          )}

          {tender?.isBorne === "false" && tender?.bank === "OWN" && (
            <>
              <Grid2 size={{ xs: 12, sm: 4 }}>
                <label htmlFor="purchaseBank">Bank Name</label>
                <input
                  type="text"
                  id="purchaseBank"
                  name="purchaseBank"
                  className={`${errors.purchaseBank && "input-error"}`}
                  onChange={handleChange}
                  value={tender && tender.purchaseBank}
                />
                {errors.purchaseBank && (
                  <p className="error">{errors.purchaseBank}</p>
                )}
              </Grid2>

              <Grid2 size={{ xs: 12, sm: 4 }}>
                <label htmlFor="purchaseAccountNumber">
                  Bank Account Number
                </label>
                <input
                  type="text"
                  id="purchaseAccountNumber"
                  name="purchaseAccountNumber"
                  className={`${errors.purchaseAccountNumber && "input-error"}`}
                  onChange={handleChange}
                  value={tender && tender.purchaseAccountNumber}
                />
                {errors.purchaseAccountNumber && (
                  <p className="error">{errors.purchaseAccountNumber}</p>
                )}
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 4 }}>
                <label htmlFor="purchaseIfsc">IFSC</label>
                <input
                  type="text"
                  id="purchaseIfsc"
                  name="purchaseIfsc"
                  className={`${errors.purchaseIfsc && "input-error"}`}
                  onChange={handleChange}
                  value={tender && tender.purchaseIfsc}
                />
                {errors.purchaseIfsc && (
                  <p className="error">{errors.purchaseIfsc}</p>
                )}
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 4 }}>
                <label htmlFor="purchaseAccountName">Beneficiary Name</label>
                <input
                  type="text"
                  id="purchaseAccountName"
                  name="purchaseAccountName"
                  className={`${errors.purchaseAccountName && "input-error"}`}
                  onChange={handleChange}
                  value={tender && tender.purchaseAccountName}
                />
                {errors.purchaseAccountName && (
                  <p className="error">{errors.purchaseAccountName}</p>
                )}
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 4 }}>
                <label htmlFor="purchaseAmount">
                  Tender Purchase Amount (in &#8377;)
                </label>
                <input
                  type="number"
                  min={0}
                  name="purchaseAmount"
                  id="purchaseAmount"
                  className={`${errors.purchaseAmount && "input-error"}`}
                  onChange={handleChange}
                  value={tender && tender.purchaseAmount}
                />
                <p style={{ fontSize: "12px", lineHeight: "-1px" }}>
                  [Note: Cost of this tender will be borne by suppliers.
                  Purchase amount should be 0.1% of Tender Value or Rs. 10,000,
                  whichever is lower]
                </p>
                {errors.purchaseAmount && (
                  <p className="error">{errors.purchaseAmount}</p>
                )}
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 4 }}>
                <label htmlFor="purchaseAccountType">Account Type</label>
                <input
                  type="text"
                  id="purchaseAccountType"
                  name="purchaseAccountType"
                  className={`${errors.purchaseAccountType && "input-error"}`}
                  onChange={handleChange}
                  value={tender && tender.purchaseAccountType}
                />
                {errors.purchaseAccountType && (
                  <p className="error">{errors.purchaseAccountType}</p>
                )}
              </Grid2>
            </>
          )}
        </Grid2>
      </div>
      <Box className="btn-container" sx={{ gap: 3 }}>
        <Button className="btn-outlined" onClick={handleBack}>
          Back
        </Button>
        <Button
          className="btn-contained"
          onClick={handleNext}
          disabled={btnLoading}
        >
          {btnLoading ? "Submitting..." : "Next"}
        </Button>
      </Box>
    </div>
  );
};

export default Step2;
